import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
const { CallApi } = require("app/_helpers/CallApi/CallApi");

export const trainingTypes = {
  category: "Category",
  workArea: "Work Area",
  complianceCategory: "Compliance Category",
  event: "Event",
  meetingGroup: "Meeting Group",
  workPermit: "Work Permit",
  fireAlarmPoint: "Fire Alarm Point",
};

export async function getAllTrainings(filter) {
  let url = "/global-configuration/ehs-module/all-trainings?";

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAllTrainingCategories(filter) {
  let url = `/global-configuration/ehs-module/all-trainings?filter[type]=${trainingTypes.category}&`;

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAllWorkAreas(filter) {
  let url = `/global-configuration/ehs-module/all-trainings`;

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAllComplianceCategories(filter) {
  let url = `/global-configuration/ehs-module/all-trainings?filter[type]=${trainingTypes.complianceCategory}&`;

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export async function getAllFireAlarmPoints(filter) {
  let url = `/global-configuration/ehs-module/all-trainings?filter[type]=${trainingTypes.fireAlarmPoint}&`;

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function createTraining(data) {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/create-training",
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export const createByExcel = async (data) => {
  let url = "/global-configuration/ehs-module/create-training/excel";
  return await CallApi(url, "POST", data);
};
export const downloadByExcel = async (data) => {
  let url = "/global-configuration/ehs-module/download-by-excel";
  return await CallApi(url, "GET", data);
};

export async function updateTraining(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-training/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function deleteTraining(id) {
  try {
    const response = await RestMethod.DELETE(
      "/global-configuration/ehs-module/delete-training/" + id
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAllTrainingCourses(filter) {
  let url = "/global-configuration/ehs-module/all-training-courses?";

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function createTrainingCourse(data) {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/create-training-course",
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateTrainingCourse(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-training-course/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function deleteTrainingCourse(id) {
  try {
    const response = await RestMethod.DELETE(
      "/global-configuration/ehs-module/delete-training-course/" + id
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export async function addReleaseNotes(data) {
  let url = "/global-configuration/ehs-module/release-notes/add";
  return await CallApi(url, "POST", data);
}
export async function updateReleaseNotes(id, data) {
  let url = "/global-configuration/ehs-module/release-notes/update/" + id;
  return await CallApi(url, "PUT", data);
}
export async function getAllReleaseNotes() {
  let url = "/global-configuration/ehs-module/release-notes/all";
  return await CallApi(url, "GET");
}
